import { useState } from 'react';
import type { Send } from '../../types/send';
import type { TimePeriod } from '../../utils/stats-utils';
import ClimbStyleRadarChart from './ClimbStyleRadarChart';
import ClimbStyleDistributionChart from './ClimbStyleDistributionChart';
import ClimbStyleOverTime from './ClimbStyleOverTime';
import ClimbStyleEffortChart from './ClimbStyleEffortChart';
import ClimbStyleEffortOverTime from './ClimbStyleEffortOverTime';

interface AllGymsStatsProps {
  sends: Send[];
}

export default function AllGymsStats({ sends }: AllGymsStatsProps) {
  const [period, setPeriod] = useState<TimePeriod>('month');

  return (
    <div className="flex flex-col gap-4">
      <ClimbStyleRadarChart sends={sends} />
      <ClimbStyleEffortChart sends={sends} />
      <ClimbStyleEffortOverTime sends={sends} period={period} onPeriodChange={setPeriod} />
      <ClimbStyleDistributionChart sends={sends} />
      <ClimbStyleOverTime sends={sends} period={period} onPeriodChange={setPeriod} />
    </div>
  );
}
